'use client';

import { shallow } from 'zustand/shallow';
import { useChatStore } from './chat-store';
import type { UniversalChatContextValue } from './types';

export const useUniversalChat = (): UniversalChatContextValue =>
  useChatStore(
    (state) => ({
      openChat: state.openChat,
      closeChat: state.closeChat,
      toggleChat: state.toggleChat,
      startFresh: state.startFresh,
      registerContext: state.registerContext,
      appendMessages: state.appendMessages,
      updateMessage: state.updateMessage,
      isOpen: state.isOpen,
      isEnabled: state.isEnabled,
      snapshot: state.snapshot,
    }),
    shallow
  );

export type { UniversalChatContextPayload, UniversalChatContextValue } from './types';
